var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vx-checkbox',{staticClass:"cursor-pointer",attrs:{"value":_vm.value,"indeterminate":_vm.indeterminate,"name":_vm.name},on:{"input":_vm.update}})}
var staticRenderFns = []

export { render, staticRenderFns }